export default "__VITE_ASSET__6f27fa30__"